import { type AccordionProps } from "./Interfaces";
import { useAccordion } from "./useAccordion";
import { Arrow } from "@assets";

export const Accordion = ({ Title, children, isOS, status, hasReincident }: AccordionProps) => {
  const helper = useAccordion(isOS);

  return (
    <div
      className={`w-full mt-[10px] mb-[10px] border border-[#b0b8be] rounded-[8px] ${hasReincident ? "border-[#D3BE96]" : ""} ${hasReincident ? "bg-[#FCF0D8]" : ""}`}
    >
      <header
        className="w-full h-[40px] flex items-center justify-between hover:bg-[#F5F7F9] cursor-pointer rounded-[8px]"
        onClick={helper.toggle}
      >
        <p className="w-full text-[#2F3941] ml-[20px] text-[12px] flex justify-between items-center">
          <span>{Title}</span>{" "}
          <span
            className="px-2 py-1 rounded-md text-black mr-[5px] px-[8px] py-[3px] rounded-[5px] text-[10px]"
            style={{ backgroundColor: helper.getStatusColor(status ?? "") }}
          >
            {status ?? ""}
          </span>
        </p>
        <img
          src={Arrow}
          alt="arrow"
          className={`mr-[20px] transition-transform duration-300 ${
            helper.isOpen ? "rotate-180" : "rotate-0"
          }`}
        />
      </header>
      <div
        ref={helper.contentRef}
        style={{ maxHeight: helper.maxHeight }}
        className="px-[20px] overflow-hidden transition-[max-height] duration-500 ease-in-out"
      >
        {children}
      </div>
    </div>
  );
};
